import { takeLatest } from 'redux-saga/effects';
import { FETCH_PATIENT_PORTAL_INTEGRATIONS } from '../../redux/modules/patientPortalIntegration/patientPortalIntegration-actions';
import fetchPatientPortalIntegrationsWorker from './patientPortalIntegrationWorkerSaga';

function* fetchPatientPortalIntegrationsWatcher() {
    yield takeLatest(FETCH_PATIENT_PORTAL_INTEGRATIONS, fetchPatientPortalIntegrationsWorker);
}

export default fetchPatientPortalIntegrationsWatcher;
